import { $, $$, onReady, isMobile } from '../nth-ms26-core/js/env';
import { ratio, syncBodyHeight } from '../nth-ms26-core/js/scale';

/*
 * Bài HTML có cảnh ghim (position:sticky — vd "Sinh nhật 10 năm": cảnh đứng yên, cuộn hết chữ mới qua cảnh sau).
 * Trang cuộn bằng <html> còn #MS__wrapper bị lib scale bằng transform → sticky không ghim (body/wrapper
 * overflow:hidden) hoặc ghim lệch dần theo tỉ lệ scale. Mainsite cũ cuộn trong khung .content NẰM TRONG wrapper
 * nên đúng → làm y vậy: bọc nội dung wrapper vào khung cuộn cao bằng màn hình (--dh, px thiết kế).
 * Script của bài tự dò khung cuộn này (findScroller) và gắn Lenis vào đó như trên mainsite cũ.
 * Bài thường không có sticky → giữ cuộn trang bình thường.
 */
function makeScroller(post) {
  const wrapper = document.getElementById('MS__wrapper');
  if (!wrapper) return null;
  const sticky = $$('.prose *', post).some((el) => getComputedStyle(el).position === 'sticky');
  if (!sticky) return null;
  const box = document.createElement('div');
  box.className = 'post-scroller';
  box.tabIndex = -1; // nhận focus để phím ↑↓ PgUp PgDn Space cuộn khung này
  while (wrapper.firstChild) box.appendChild(wrapper.firstChild);
  wrapper.appendChild(box);
  syncBodyHeight();
  box.focus({ preventScroll: true });

  // lăn chuột trên sidebar/header (lớp .MS__outer nằm ngoài khung) vẫn cuộn bài
  window.addEventListener('wheel', (e) => {
    if (e.ctrlKey || box.contains(e.target)) return;
    for (let n = e.target; n && n !== document.body; n = n.parentElement) {
      const oy = getComputedStyle(n).overflowY;
      if ((oy === 'auto' || oy === 'scroll') && n.scrollHeight > n.clientHeight + 1) return;
    }
    // Lenis của bài (gắn class .lenis lên khung) ghi đè scrollTop → chuyển cú lăn cho nó tự làm mượt
    if (box.classList.contains('lenis')) {
      box.dispatchEvent(new WheelEvent('wheel', { deltaX: e.deltaX, deltaY: e.deltaY, deltaMode: e.deltaMode, cancelable: true }));
    } else box.scrollBy({ top: e.deltaY, behavior: 'auto' });
  }, { passive: true });
  return box;
}

onReady(() => {
  const post = $('.post');
  if (!post) return;

  const scroller = makeScroller(post);
  const scrollTarget = scroller || window;
  // vị trí cuộn theo px màn hình (khung cuộn nằm trong wrapper đã scale → nhân ratio)
  const scrollY = () => (scroller ? scroller.scrollTop * ratio() : window.scrollY);

  // Nút quay lại: vào bài từ trang danh sách cùng site → lùi lịch sử (giữ đúng trang/danh mục đang xem)
  const back = $('[data-back]', post);
  if (back) {
    back.addEventListener('click', (e) => {
      try {
        const ref = new URL(document.referrer);
        if (ref.origin === window.location.origin && window.history.length > 1) {
          e.preventDefault();
          window.history.back();
        }
      } catch (err) { /* không có referrer → đi theo href */ }
    });
  }

  // Nút quay lại bám màn hình khi cuộn như mainsite cũ (feedback khách 19/10).
  // #MS__wrapper bị scale bằng transform → position fixed/sticky bên trong chạy sai, nên chuyển nút sang lớp
  // .MS__outer cố định (cùng nút lên đầu trang): trôi theo bài từ chỗ cũ, chạm mép trên thì dừng lại.
  const layer = $('[data-to-top]') && $('[data-to-top]').closest('.MS__outer');
  if (back && layer) {
    const r = ratio();
    const rect = back.getBoundingClientRect();
    const baseY = (rect.top + scrollY()) / r;
    back.style.left = `${rect.left / r}px`;
    back.classList.add('is-pinned', 'is-interactive');
    layer.appendChild(back);
    const minY = isMobile() ? 104 : 40; // MB: ngay dưới header, ngang nút Sáng/Tối
    let ticking = false;
    const place = () => {
      ticking = false;
      back.style.top = `${Math.max(minY, baseY - scrollY() / ratio())}px`;
    };
    scrollTarget.addEventListener('scroll', () => {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(place);
      }
    }, { passive: true });
    place();
  }

  // Bảng trong bài có thể rộng hơn cột chữ → bọc khung cuộn ngang
  $$('.prose table', post).forEach((table) => {
    if (table.parentElement.classList.contains('prose__scroll')) return;
    const wrap = document.createElement('div');
    wrap.className = 'prose__scroll';
    table.parentNode.insertBefore(wrap, table);
    wrap.appendChild(table);
  });

  // Ảnh trong bài: tải lười + giải mã nền (bài dài nhiều ảnh không làm khựng lúc cuộn)
  $$('.prose img', post).forEach((img, i) => {
    if (i > 1 && !img.hasAttribute('loading')) img.loading = 'lazy';
    img.decoding = 'async';
  });

  const toTop = $('[data-to-top]');
  if (toTop) {
    let ticking = false;
    const update = () => {
      ticking = false;
      toTop.classList.toggle('is-visible', scrollY() > window.innerHeight * 0.6);
    };
    scrollTarget.addEventListener('scroll', () => {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(update);
      }
    }, { passive: true });
    toTop.addEventListener('click', () => scrollTarget.scrollTo({ top: 0, behavior: 'smooth' }));
    update();
  }
});
